import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateInternshipLocationImageUseCaseInterface } from 'domain/usecases';

export class RemoteUpdateInternshipLocationImage
  implements UpdateInternshipLocationImageUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: UpdateInternshipLocationImageUseCaseInterface.Params,
  ): Promise<UpdateInternshipLocationImageUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const requestUrl = `${this.url}/${id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      body: restParams,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
